import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";

function HandheldPasswordSetting(props) {
  const [handheldPassword, setHandheldPassword] = React.useState(props.setting.value);
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <Grid container alignItems={"center"} spacing={1}>
              <Grid item xs={4}>
                <TextField
                  disabled={!write}
                  inputProps={{ maxLength: 5 }}
                  value={handheldPassword}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9]+/g, "");
                    setHandheldPassword(value);
                  }}
                  onBlur={(e) => {
                    props.onChange(handheldPassword);
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography>{props.label}</Typography>
              </Grid>
            </Grid>
            {props.children}
          </>
        );
      }}
    />
  );
}

export default HandheldPasswordSetting;
